/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";

import { ThemeUIControllerProvider } from "context";

ReactDOM.render(
  <BrowserRouter>
    <ThemeUIControllerProvider>
      <App />
    </ThemeUIControllerProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
